import { render, staticRenderFns } from "./campusDetails.vue?vue&type=template&id=3d3d2c3d&scoped=true&"
import script from "./campusDetails.vue?vue&type=script&lang=js&"
export * from "./campusDetails.vue?vue&type=script&lang=js&"
import style0 from "./campusDetails.vue?vue&type=style&index=0&id=3d3d2c3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d2c3d",
  null
  
)

export default component.exports